import { BaseModule } from "./base.module";

/**
 * An adapter for bridging existing custom javascript events on the one side, and cookiebot events on the other side
 */
export class CookieAdapterModule extends BaseModule {

    initialize() {
        this.setEventListeners();
    }

    setEventListeners() {
        window.addEventListener('CookiebotOnConsentReady', (event) => {
            // This is defined as anonymous statistics as per description in the Cookiebot cookie overlay.
            // This is used in the UTM Module
            if (
                Cookiebot.consent.statistics === true
            ) {
                this.triggerEventOnElement('anonymous-analytics-cookies-accepted', document);
            }
            // if statistics consent AND marketing consent is given, this constitutes acceptance of
            // non-functional cookies (required by current EU law)
            if (
                Cookiebot.consent.statistics === true
                &&
                Cookiebot.consent.marketing === true
            ) {
                this.triggerEventOnElement('non-functional-cookies-accepted', document);
            }
            // send custom event which easily hooks into other modules
            // this is used in AnalyticsModule which may store a uuid in an identifying way
            // though in current practice it is not used actively anywhere @ 18-8-2026 (we use an external platform)
            if (
                Cookiebot.consent.marketing === true
            ) {
                this.triggerEventOnElement('marketing-cookies-accepted', document);
            }

            if (
                Cookiebot.consent.statistics === false
            ) {
                this.triggerEventOnElement('anonymous-analytics-cookies-declined', document);
            }
            // if statistics consent AND marketing consent is given, this constitutes acceptance of
            // non-functional cookies (required by current EU law)
            if (
                Cookiebot.consent.statistics === false
                &&
                Cookiebot.consent.marketing === false
            ) {
                this.triggerEventOnElement('non-functional-cookies-declined', document);
            }
            // send custom event which easily hooks into other modules
            // this is used in AnalyticsModule which may store a uuid in an identifying way
            // though in current practice it is not used actively anywhere @ 18-8-2026 (we use an external platform)
            if (
                Cookiebot.consent.marketing === false
            ) {
                this.triggerEventOnElement('marketing-cookies-declined', document);
            }

        });
        window.addEventListener('CookiebotOnDialogInit', (event) => {
            // make an assumption: the cookie bot dialog always shows when no choice has been made yet.
            // so we regard this event as an event that will trigger either when the user first visits the domain
            // or when this dialog was triggered again after some revocation or change of cookies, like clicking from marketing iframe accept button (as of writing of commit)
            // alert(`CookiebotOnDialogInit`);
            // this.triggerEventOnElement('revoke-cookie-choice', document);
            let component = document.getElementById('CookiebotWidget');
            if (
                component
            ) {
                component.style['display'] = `none`;
            }
        });
    }
}